/* eslint-disable react/function-component-definition */
import React, { useImperativeHandle, useState } from 'react';
import RoboneoModal from '$/components/Modal';
import { useLanguageStore } from '$/store/languageStore';
import Button from '$/components/base/Button';
import styles from './index.module.scss';

export interface InvoiceManagementModalRef {
  open: () => void;
}

interface InvoiceManagementModalProps {
}

// 发票管理弹窗，按 Figma 设计展示开票联系说明。
const InvoiceManagementModal: React.ForwardRefRenderFunction<InvoiceManagementModalRef, InvoiceManagementModalProps> = (props, ref) => {
  const [open, setOpen] = useState(false);
  const languageStore = useLanguageStore((state) => state.languageStore);

  // 关闭发票管理弹窗。
  const handleClose = () => {
    setOpen(false);
  };

  useImperativeHandle(ref, () => ({
    open: () => {
      setOpen(true);
    },
  }));

  return (
    <RoboneoModal
      wrapClassName={styles.invoiceModalWrapper}
      bodyClassName={styles.invoiceModalBody}
      open={open}
      onCancel={handleClose}
      closable
      width={480}
    >
      <div className={styles.invoiceHeader} />
      <div className={styles.invoiceDesc}>
        {languageStore.smartcatTranslationText((v) => v.contact_4000093360_roboneo_com_for_express_invoice_processing)}
      </div>
      <div className={styles.invoiceFooter}>
        <Button
          type="plain"
          className={styles.confirmButton}
          onClick={handleClose}
        >
          {languageStore.smartcatTranslationText((v) => v.roboneo_web_ot)}
        </Button>
      </div>
    </RoboneoModal>
  );
};

export default React.forwardRef(InvoiceManagementModal);
